import React from "react";
import "./RotateModal.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { addPageImageRotate } from "../../api/pages";

class RotateModal extends React.Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
    this.rotateClicked = this.rotateClicked.bind(this);
    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);
    this.renderImage = this.renderImage.bind(this);

    this.state = {
      isProcessing: false,
      degree: 270
    };
  }

  async save() {
    const { pageID, imageID } = this.props;
    let { degree } = this.state;

    if (degree <= 0) {
      toast.error("no rotation");
      return;
    }

    this.setState({ isProcessing: true });

    try {
      if (degree === 90) {
        degree = 270;
      } else if (degree === 270) {
        degree = 90;
      }

      await addPageImageRotate(pageID, imageID, degree);
      this.setState({
        isProcessing: false,
        degree: 270
      });
      this.props.handleCloseModal(true);
    } catch (e) {
      toast.error(e.toString());
      this.setState({ isProcessing: false });
    }
  }

  handleCloseCreateModal() {
    this.setState({
      isProcessing: false,
      degree: 270
    });

    this.props.handleCloseModal(false);
  }

  rotateClicked() {
    this.setState({ degree: (this.state.degree + 270) % 360 });
  }

  renderImage() {
    return (
      <React.Fragment>
        <Row className="rotate_image_container">
          <Image
            style={{ transform: `rotate(${this.state.degree}deg)` }}
            className="rotating_img"
            src={`${process.env.REACT_APP_API_ROOT}artworks/${
              this.props.imageID
            }/static`}
          />
        </Row>
        <Row>
          <Col style={{ textAlign: "center" }}>
            <Button
              variant="primary"
              size="sm"
              disabled={this.state.isProcessing}
              onClick={this.rotateClicked}
            >
              <span className="fa fa-undo" />
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
      >
        <Modal.Body>
          <Container>{this.renderImage()}</Container>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
            disabled={this.state.isProcessing}
          >
            Close
          </Button>
          <Button
            onClick={this.save}
            variant="info"
            disabled={this.state.isProcessing}
          >
            Save
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isProcessing && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RotateModal;
